enum CasesEnum {
    unleashNewGrowthDrivers = "cn.unleashNewGrowthDrivers",  // 开启增长新动力
    over2000 = "cn.over2000", // 超2000+
    commonCoiceOfChainBrands = "cn.commonCoiceOfChainBrands", // 连锁品牌的共同选择
    consultNow = "cn.consultNow", // 立即咨询
    RestosuiteAndHisFriends = "cn.RestosuiteAndHisFriends", // 睿食拓和TA的朋友们
    trustFromGlobalCustomers = "cn.trustFromGlobalCustomers", // 全球客户的信赖
    infinitePossibilitiesTogether = "cn.infinitePossibilitiesTogether", // 我们帮助有梦想的餐饮品牌开遍全球
    unlockGrowth = "cn.unlockGrowth", // 开启增长
    customerStoriesFromVariousIndustries = "cn.customerStoriesFromVariousIndustries", // 来自千行百业的客户故事
    theseMerchantsAreAllUsing = "cn.theseMerchantsAreAllUsing",//  这些商户都在使用
    resto = "cn.resto",//  
    all = "cn.all", // 全部
    more = "cn.more" // 更多
}

export default CasesEnum